interface LogoProps {
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
}

const sizeConfig = {
  sm:  { mark: 28, fF: 11, fW: 10, name: 'text-[10px]', gap: 'gap-2' },
  md:  { mark: 40, fF: 15, fW: 14, name: 'text-[12px]', gap: 'gap-2.5' },
  lg:  { mark: 54, fF: 20, fW: 18, name: 'text-[15px]', gap: 'gap-3' },
};

export default function Logo({ variant = 'light', size = 'md' }: LogoProps) {
  const s      = sizeConfig[size];
  const isDark = variant === 'dark';
  const m      = s.mark;

  const markW = Math.round(m * 0.68);

  const fontBase: React.CSSProperties = {
    fontFamily: "'Impact','Arial Narrow','Haettenschweiler',sans-serif",
    fontWeight: 900,
    lineHeight: 1,
    letterSpacing: '-0.01em',
    color: '#C8953A',
    display: 'block',
  };

  const wordColor = isDark ? '#111111' : '#ffffff';

  return (
    <div className={`flex items-center ${s.gap} flex-shrink-0`}>

      {/* ── Bookmark Monogram ── */}
      <div
        className="relative flex-shrink-0 select-none"
        style={{
          width:    markW,
          height:   m,
          clipPath: 'polygon(0 0, 100% 0, 100% 76%, 50% 100%, 0 76%)',
          background: '#1e1c1a',
        }}
      >
        {/* F — upper half */}
        <div
          className="absolute flex items-center justify-center"
          style={{ top: '5%', left: '8%', right: '8%', height: '46%' }}
        >
          <span style={{ ...fontBase, fontSize: s.fF }}>F</span>
        </div>

        {/* Divider */}
        <div
          className="absolute left-0 right-0"
          style={{ top: '51%', height: 1, background: 'rgba(255,255,255,0.15)' }}
        />

        {/* W — lower half */}
        <div
          className="absolute flex items-center justify-center"
          style={{ top: '52%', left: '6%', right: '6%', bottom: '24%' }}
        >
          <span style={{ ...fontBase, fontSize: s.fW }}>W</span>
        </div>
      </div>

      {/* ── Wordmark ── */}
      <div className="flex flex-col leading-none">
        <span
          className={`font-black tracking-[0.2em] uppercase whitespace-nowrap ${s.name}`}
          style={{ fontFamily: "'Montserrat','Arial Black',sans-serif" }}
        >
          <span style={{ color: wordColor }}>FOR</span><span style={{ color: '#C8953A' }}>WARD</span>
        </span>
        <span
          className="tracking-[0.32em] uppercase whitespace-nowrap mt-[3px]"
          style={{
            fontSize:   '7px',
            fontFamily: "'Montserrat',sans-serif",
            fontWeight: 500,
            color: isDark ? 'rgba(12,12,12,0.4)' : 'rgba(255,255,255,0.4)',
          }}
        >
          COMPANY
        </span>
      </div>
    </div>
  );
}
